import api from '../lib/api';

export interface GladlyConfig {
  username: string;
  apiToken: string;
  organizationDomain: string;
}

export interface GladlyStatus {
  connected: boolean;
  lastSync?: string;
  organizationDomain?: string;
}

export const gladlyService = {
  // Connect to Gladly
  async connect(organizationId: string, config: GladlyConfig) {
    const response = await api.post('/integrations/gladly/connect', {
      organizationId,
      config,
    });
    return response.data;
  },

  // Test connection
  async testConnection(organizationId: string) {
    const response = await api.get(`/integrations/gladly/${organizationId}/test`);
    return response.data;
  },

  // Get integration status
  async getStatus(organizationId: string): Promise<GladlyStatus> {
    const response = await api.get(`/integrations/gladly/${organizationId}/status`);
    return response.data;
  },

  // Sync agents from Gladly
  async syncAgents(organizationId: string) {
    const response = await api.post(`/integrations/gladly/${organizationId}/sync-agents`);
    return response.data;
  },

  // Fetch conversation metrics
  async fetchMetrics(organizationId: string, startDate: string, endDate: string) {
    const response = await api.post(`/integrations/gladly/${organizationId}/fetch-metrics`, {
      startDate,
      endDate,
    });
    return response.data;
  },

  // Sync historical conversation data for forecasting
  async syncHistorical(
    organizationId: string,
    startDate: string,
    endDate: string,
  ) {
    const response = await api.post(`/integrations/gladly/${organizationId}/sync-historical`, {
      startDate,
      endDate,
    });
    return response.data;
  },

  // Disconnect integration
  async disconnect(organizationId: string) {
    const response = await api.post(`/integrations/gladly/${organizationId}/disconnect`);
    return response.data;
  },
};
